import clsx from 'clsx';
import React, { useState } from 'react';

// Hooks
import useSocialProfiles from '@/hooks/swr/useSocialProfiles';
import {
    REPLACE_SOCIAL_PROFILE,
    REPLACE_GROUP,
    useDashboardContext
} from '@/hooks/context/useDashboardContext';
import useSPGroups from '@/utils/hooks/swr/group/useSPGroups';

// Components
import Icon from '@/components/base/Icon';
import SelectSpWidgetDashboardView from '@/components/pages/custom-dashboards/dashboard/select/SelectSPWidgetDashboardView';
import SelectGroupWidgetDashboardView from '@/components/pages/custom-dashboards/dashboard/select/SelectGroupWidgetDashboardView';
import CustomDashboardPopover from '@/components/pages/custom-dashboards/dashboard/CustomDashboardPopover';

const CustomDashboardWidgetActions = ({ children }) => {
    return (
        <div className="absolute left-0 top-0 flex w-full items-center justify-between px-2 py-5">
            {children}
        </div>
    );
};

const WidgetActionSelectSP = ({
    socialProfiles,
    setRequestParams = () => {
        /** */
    },
    setSocialProfileSelected = () => {
        /** */
    },
    config,
    isMedia = false
}) => {
    const { dispatch } = useDashboardContext();
    const { activatedSocialProfiles } = useSocialProfiles({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const [selectedSP, setSelectedSP] = useState(
        activatedSocialProfiles.find((social_profile) => social_profile.id === socialProfiles[0])
    );

    const handleOnSelect = (social_profile) => {
        setSelectedSP(social_profile);
        dispatch({
            type: REPLACE_SOCIAL_PROFILE,
            payload: {
                id: config.widgetUniqId,
                spId: social_profile.id
            }
        });

        if (isMedia) {
            setSocialProfileSelected(social_profile);
        } else {
            setRequestParams({ ...config, social_profiles: [social_profile.id] });
        }
    };

    return (
        <SelectSpWidgetDashboardView
            selectedSP={selectedSP}
            setSelectedSP={handleOnSelect}
            networks={config?.dashboardEligibleNetworks ?? [selectedSP.social_network_type]}
            avatarSize="sm"
            noValue
            sizeStyle="noValue"
            baseStyle="transparentBackground"
        />
    );
};

CustomDashboardWidgetActions.SelectSP = WidgetActionSelectSP;

const WidgetActionsSelectGroup = ({
    groups,
    setRequestParams = () => {
        /** */
    },
    setGroupSelected = () => {
        /** */
    },
    config,
    isMedia = false
}) => {
    const { dispatch } = useDashboardContext();
    const { activatedSpGroups } = useSPGroups({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const [selectedGroup, setSelectedGroup] = useState(
        activatedSpGroups.find((group) => group.id === groups[0])
    );

    const handleOnSelect = (group) => {
        setSelectedGroup(group);
        dispatch({
            type: REPLACE_GROUP,
            payload: {
                id: config.widgetUniqId,
                groupId: group.id
            }
        });

        if (isMedia) {
            setGroupSelected(group);
        } else {
            setRequestParams({ ...config, groups: [group.id] });
        }
    };

    return (
        <SelectGroupWidgetDashboardView
            selectedGroup={selectedGroup}
            setSelectedGroup={handleOnSelect}
            avatarSize="sm"
            noValue
            sizeStyle="noValue"
            baseStyle="transparentBackground"
            avatarGroupIcon={true}
        />
    );
};

CustomDashboardWidgetActions.SelectGroup = WidgetActionsSelectGroup;

const WidgetActionsPopover = ({ children, className }) => (
    <CustomDashboardPopover
        className={clsx('flex h-10 w-10 items-center justify-center rounded-full', className)}
        panel={<ul className="space-y-1 p-1 text-sm">{children}</ul>}>
        <Icon className="text-icoGray-500 dark:text-white" icon="dots" />
    </CustomDashboardPopover>
);

CustomDashboardWidgetActions.Popover = WidgetActionsPopover;

export default CustomDashboardWidgetActions;
